import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from 'src/app/services/http-client.service';

@Injectable()
export class HomeService {
    constructor(private _httpService: HttpClientService) { }

    getLatestCourse(): Observable<any> {
        return this._httpService.get<any>(
            '/courses/latest'
        );
    }

    getLatestEvents(): Observable<any> {
        return this._httpService.get<any>(
            '/events/latest'
        );
    }

    getLatestBlogs(): Observable<any> {
        return this._httpService.get<any>(
            '/blogs/latest'
        );
    }

    postEventUserRegistration(eventUserModel: any): Observable<any> {
        return this._httpService.post<any, any>(
            '/eventUser', eventUserModel
        );
    }

}
